import { render, staticRenderFns } from "./phoneCost.vue?vue&type=template&id=6fc91574&scoped=true&"
import script from "./phoneCost.vue?vue&type=script&lang=js&"
export * from "./phoneCost.vue?vue&type=script&lang=js&"
import style0 from "./phoneCost.vue?vue&type=style&index=0&id=6fc91574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc91574",
  null
  
)

export default component.exports